import { useState, useEffect } from 'react';
import { Card, CardMedia, Typography, Box, Paper, CircularProgress } from '@mui/material';
import fetchAndExtractArticleData from '../utils/extractArticleData';

function System() {
  const [announcements, setAnnouncements] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        setLoading(true);

        const articleData = await fetchAndExtractArticleData('en', 'system');

        console.log('Extracted article data:', articleData);

        // Transform extracted data to match our component's expected format
        const transformedData = articleData.map((item, index) => ({
          id: index + 1,
          documentId: `article-${index + 1}`,
          title: item.title || 'Untitled',
          content: item.content || '',
        }));

        setAnnouncements(transformedData);
        if (transformedData.length > 0) {
          setSelectedItem(transformedData[0]);
        }
        setError(null);
      } catch (err) {
        console.error('Error fetching announcements:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Typography color="error">Error loading announcements: {error}</Typography>
      </Box>
    );
  }

  if (announcements.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Typography>No system announcements available</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{
      flexGrow: 1,
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      overflow: 'hidden'
    }}>
      <Box sx={{
        width: { xs: '140px', sm: '200px', md: '260px' },
        minWidth: { xs: '140px', sm: '200px', md: '260px' },
        maxWidth: { xs: '140px', sm: '200px', md: '260px' },
        paddingTop: { xs: 1, sm: 1.5, md: 2 },
        paddingBottom: { xs: 0.5, sm: 1, md: 1.5 },
        paddingLeft: { xs: 0.5, sm: 1, md: 1.5 },
        paddingRight: { xs: 1.5, sm: 2, md: 2.5 },
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        overflowY: 'auto',
        overflowX: 'visible',
        flexShrink: 0,
        backgroundColor: 'transparent'
      }}>
        {announcements.map((item) => (
          <Box key={item.id} sx={{ position: 'relative', overflow: 'visible' }}>
            <Card
              onClick={() => setSelectedItem(item)}
              sx={{
                cursor: 'pointer',
                border: selectedItem.id === item.id ? '6px solid #ff5722' : 'none',
                borderRadius: '12px',
                overflow: 'hidden',
                '&:hover': {
                  boxShadow: 4
                }
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  aspectRatio: '3/2',
                  backgroundColor: '#f0f0f0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Typography variant="caption" color="text.secondary">
                  {item.title}
                </Typography>
              </Box>
            </Card>
            {selectedItem.id === item.id && (
              <Box
                sx={{
                  position: 'absolute',
                  right: { xs: '-10px', sm: '-10px', md: '-12px' },
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: 0,
                  height: 0,
                  borderTop: { xs: '10px solid transparent', sm: '10px solid transparent', md: '12px solid transparent' },
                  borderBottom: { xs: '10px solid transparent', sm: '10px solid transparent', md: '12px solid transparent' },
                  borderLeft: { xs: '12px solid #ff5722', sm: '12px solid #ff5722', md: '14px solid #ff5722' },
                  zIndex: 1
                }}
              />
            )}
          </Box>
        ))}
      </Box>

      <Box sx={{ flex: 1, paddingTop: { xs: 1, md: 2 }, paddingBottom: { xs: 1, md: 2 }, paddingLeft: 0, paddingRight: { xs: 1, md: 2 }, display: 'flex', flexDirection: 'column' }}>        <Paper elevation={3} sx={{
          padding: { xs: 2, sm: 2.5, md: 3 },
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto'
        }}>
          <iframe
            src={selectedItem.content}
            title={selectedItem.title}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '6px'
            }}
          />
        </Paper>
      </Box>
    </Box>
  );
}

export default System;
